import moment from 'moment-timezone';

const getTimezoneName = (timezone) =>
  timezone.startsWith('+') || timezone.startsWith('-')
    ? `UTC${timezone}`
    : timezone;

const getDateStr = ({ startDate, endDate, timezone }) => {
  const localStartDate = moment.tz(startDate, timezone);
  const localEndDate = moment.tz(endDate, timezone);

  const localStartTimezoneName = getTimezoneName(localStartDate.format('z'));
  const localEndTimezoneName = getTimezoneName(localEndDate.format('z'));
  const dateElems = [];
  const localStartTime = localStartDate.format('LT');
  const localEndTime = localEndDate.format('LT');

  if (localStartDate.format('L') === localEndDate.format('L')) {
    dateElems.push(moment.tz(startDate, timezone).format('LL'));
    dateElems.push(localStartTime);

    if (
      localStartTime === localEndTime ||
      localStartTimezoneName !== localEndTimezoneName
    ) {
      dateElems.push(localStartTimezoneName);
    }
    if (localStartTime !== localEndTime) {
      dateElems.push('-');
      dateElems.push(localEndTime);
      dateElems.push(localEndTimezoneName);
    }
  } else {
    dateElems.push(localStartDate.format('LL'));
    dateElems.push(localStartTime);
    if (localStartTimezoneName !== localEndTimezoneName) {
      dateElems.push(localStartTimezoneName);
    }
    dateElems.push('-');
    dateElems.push(localEndDate.format('LL'));
    dateElems.push(localEndTime);
    dateElems.push(localEndTimezoneName);
  }

  return dateElems.join(' ');
};
export default getDateStr;
